/**
 * @file: constants.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { OrderFieldsConfig } from '@euler/model';

export const kAlwaysEnableAutomaticKeyboardInOrderFlow = true;

export type OrderFieldType =
  | 'licensePlateNo'
  | 'vin'
  | 'vehicleInfo'
  | 'vehicleModelYear'
  | 'mileage'
  | 'dashboardInfo'
  | 'facadeInfo'
  | 'orderTags'
  | 'serviceAgent'
  | 'estimatedFinishTime'
  | 'serviceSubjects'
  | 'remark'
  | 'customerType'
  | 'customerName'
  | 'customerMobile'
  | 'carwashType'
  | 'returnType'
  | 'oldPartDisposalType'
  | 'reservationType'
  | 'extendedProperty'
  | 'insuranceExpiryDate';

export type OrderPropertyName = keyof OrderFieldsConfig;

export const kEnumOrderProperties = new Set<OrderPropertyName>([
  'carwashType',
  'returnType',
  'oldPartDisposalType',
  'reservationType',
  'customerType',
]);

export const kOrderFieldTypeToPropertyNameMap = new Map<
  OrderFieldType,
  OrderPropertyName
>([
  ['licensePlateNo', 'licensePlateNo'],
  ['vin', 'vin'],
  ['vehicleInfo', 'vehicleInfo'],
  ['serviceAgent', 'serviceAgent'],
  ['orderTags', 'tags'],
  ['mileage', 'mileage'],
  ['dashboardInfo', 'dashboardImage'],
  ['facadeInfo', 'facadeInspection'],
  ['serviceSubjects', 'serviceSubjects'],
  ['carwashType', 'carwashType'],
  ['returnType', 'returnType'],
  ['oldPartDisposalType', 'oldPartDisposalType'],
  ['estimatedFinishTime', 'estimatedFinishTime'],
  ['reservationType', 'reservationType'],
  ['insuranceExpiryDate', 'insuranceExpiryDate'],
  ['customerType', 'customerType'],
  ['customerName', 'customerName'],
  ['customerMobile', 'customerMobile'],
  ['remark', 'remark'],
]);

export const kDefaultAutoFillProperties = new Set<OrderPropertyName>([
  'customerName',
  'customerMobile',
  'customerType',
  'insuranceExpiryDate',
]);
